import { Alert, Box, TextField, Typography } from '@mui/material'
import { overdueWhyLine, overdueAmountBreakdown, overdueAmountOf, overdueEmailBody, OVERDUE_TOKENS_HINT } from './overdueRefund.js'

// Return Status's overdue refund on its steps (2026-10-29, overdueRefund.js).

// The refund step: why it is there, the amount (editable) and its breakdown.
export function OverdueRefundInfo({ step, input, live, disabled = false, onAmount }) {
  const why = overdueWhyLine(step, live)
  const breakdown = overdueAmountBreakdown(step)
  const amount = overdueAmountOf(step, input)
  return (
    <Box data-testid="overdue-refund-info" sx={{ mt: 0.5 }}>
      {why && <Alert severity="info" sx={{ py: 0, mb: 0.5 }} data-testid="overdue-refund-why">{why}</Alert>}
      <TextField
        size="small" label="Refund amount" type="number" inputProps={{ step: '0.01', min: '0', 'data-testid': 'overdue-refund-amount' }}
        value={amount ?? ''} disabled={disabled}
        onChange={(e) => onAmount?.(e.target.value)}
        sx={{ width: 160 }}
      />
      {breakdown && <Typography variant="caption" color="text.secondary" display="block" data-testid="overdue-refund-breakdown">{breakdown}</Typography>}
    </Box>
  )
}

// The email to Support: To, From (fixed), Subject and Body, editable before
// it is sent.
export function OverdueSupportEmail({ step, input, live, disabled = false, onChange }) {
  const p = step?.params ?? {}
  const body = overdueEmailBody(step, input, live)
  return (
    <Box data-testid="overdue-support-email" sx={{ mt: 0.5, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <TextField size="small" label="To" value={input?.to ?? p.to ?? ''} disabled={disabled} inputProps={{ 'data-testid': 'overdue-email-to' }}
        onChange={(e) => onChange?.({ to: e.target.value })} />
      <TextField size="small" label="From" value={p.from ?? ''} disabled inputProps={{ 'data-testid': 'overdue-email-from' }} />
      <TextField size="small" label="Subject" value={input?.subject ?? p.subject ?? ''} disabled={disabled} inputProps={{ 'data-testid': 'overdue-email-subject' }}
        onChange={(e) => onChange?.({ subject: e.target.value })} />
      <TextField size="small" label="Body" multiline minRows={4} value={body} disabled={disabled} inputProps={{ 'data-testid': 'overdue-email-body' }}
        onChange={(e) => onChange?.({ body: e.target.value })} />
      {!disabled && <Typography variant="caption" color="text.secondary">{OVERDUE_TOKENS_HINT} Sent only after the refund step succeeds.</Typography>}
    </Box>
  )
}
